import { defineMessages } from 'react-intl';
const messages = defineMessages({
    Title: { id: 'CapacityPlanningTitle', defaultMessage: 'Initialise capacity planning' },
    Intro: {
        id: 'CapacityPlanningIntro',
        defaultMessage: 'Maps the time registered in a year onto your task templates and calculates the expected durations from it.',
    },
    Period: { id: 'CapacityPlanningPeriod', defaultMessage: 'Period' },
    InvalidPeriod: {
        id: 'CapacityPlanningInvalidPeriod',
        defaultMessage: 'Choose a period from 2000 until today, of at most three years.',
    },
    ShortPeriodWarning: {
        id: 'CapacityPlanningShortPeriodWarning',
        defaultMessage: 'This period is shorter than a year. Tasks that occur less often may be missing or counted on too few occurrences, so their durations are less reliable.',
    },
    StartAnalysis: { id: 'CapacityPlanningStartAnalysis', defaultMessage: 'Start analysis' },
    AnalysisDuration: {
        id: 'CapacityPlanningAnalysisDuration',
        defaultMessage: 'This can take a few minutes.',
    },
    StepPriceListItems: {
        id: 'CapacityPlanningStepPriceListItems',
        defaultMessage: 'Price list items',
    },
    StepTaskTemplates: {
        id: 'CapacityPlanningStepTaskTemplates',
        defaultMessage: 'Task templates',
    },
    StepValidation: { id: 'CapacityPlanningStepValidation', defaultMessage: 'Validation' },
    Previous: { id: 'CapacityPlanningPrevious', defaultMessage: 'Previous step' },
    Next: { id: 'CapacityPlanningNext', defaultMessage: 'Next step' },
    Save: { id: 'CapacityPlanningSave', defaultMessage: 'Save' },
    Finalize: { id: 'CapacityPlanningFinalize', defaultMessage: 'Finalise' },
    NotAvailableYet: {
        id: 'CapacityPlanningNotAvailableYet',
        defaultMessage: 'Not available yet',
    },
    KpiProductive: {
        id: 'CapacityPlanningKpiProductive',
        defaultMessage: 'Registered time for customers',
    },
    KpiMapped: { id: 'CapacityPlanningKpiMapped', defaultMessage: 'Mapped time' },
    KpiUnmapped: { id: 'CapacityPlanningKpiUnmapped', defaultMessage: 'Unmapped time' },
    KpiUnproductive: {
        id: 'CapacityPlanningKpiUnproductive',
        defaultMessage: 'Unproductive time',
    },
    KpiNeverMapped: {
        id: 'CapacityPlanningKpiNeverMapped',
        defaultMessage: 'Never mapped items',
    },
    PercentOfTotal: {
        id: 'CapacityPlanningPercentOfTotal',
        defaultMessage: '{percentage}% of total',
    },
    ItemsWithoutMapping: {
        id: 'CapacityPlanningItemsWithoutMapping',
        defaultMessage: '{count} price list items',
    },
    Search: { id: 'CapacityPlanningSearch', defaultMessage: 'Search on name or code...' },
    Code: { id: 'CapacityPlanningCode', defaultMessage: 'Code' },
    SortBy: { id: 'CapacityPlanningSortBy', defaultMessage: 'Sort by' },
    SortTotal: { id: 'CapacityPlanningSortTotal', defaultMessage: 'Total' },
    SortMapped: { id: 'CapacityPlanningSortMapped', defaultMessage: 'Mapped' },
    SortUnmapped: { id: 'CapacityPlanningSortUnmapped', defaultMessage: 'Unmapped' },
    SortUnmappedPercentage: {
        id: 'CapacityPlanningSortUnmappedPercentage',
        defaultMessage: '% unmapped',
    },
    SortNeverMappedFirst: {
        id: 'CapacityPlanningSortNeverMappedFirst',
        defaultMessage: 'Never mapped first',
    },
    PriceListItem: { id: 'CapacityPlanningPriceListItem', defaultMessage: 'Price list item' },
    Mapped: { id: 'CapacityPlanningMapped', defaultMessage: 'Mapped' },
    Unmapped: { id: 'CapacityPlanningUnmapped', defaultMessage: 'Unmapped' },
    Unproductive: { id: 'CapacityPlanningUnproductive', defaultMessage: 'Unproductive' },
    Total: { id: 'CapacityPlanningTotal', defaultMessage: 'Total' },
    UnmappedPercentage: {
        id: 'CapacityPlanningUnmappedPercentage',
        defaultMessage: '% unmapped',
    },
    Absence: { id: 'CapacityPlanningAbsence', defaultMessage: 'Absence' },
    AbsenceHint: {
        id: 'CapacityPlanningAbsenceHint',
        defaultMessage: 'Absence time is not used for the capacity planning.',
    },
    ResetMapping: {
        id: 'CapacityPlanningResetMapping',
        defaultMessage: 'Back to the automatic mapping',
    },
    EditMapping: { id: 'CapacityPlanningEditMapping', defaultMessage: 'Edit mapping' },
    ResetConfirmTitle: {
        id: 'CapacityPlanningResetConfirmTitle',
        defaultMessage: 'Undo the changes',
    },
    ResetItemConfirm: {
        id: 'CapacityPlanningResetItemConfirm',
        defaultMessage: 'Undo all changes on {name} and go back to the automatic mapping? This cannot be undone.',
    },
    ResetTemplate: {
        id: 'CapacityPlanningResetTemplate',
        defaultMessage: 'Back to the registered time',
    },
    ResetTemplateConfirm: {
        id: 'CapacityPlanningResetTemplateConfirm',
        defaultMessage: 'Undo the distribution and excluded subtasks of {name}? This cannot be undone.',
    },
    EditSubtasks: { id: 'CapacityPlanningEditSubtasks', defaultMessage: 'Edit subtasks' },
    KpiHours: { id: 'CapacityPlanningKpiHours', defaultMessage: 'hours' },
    AutomaticMappings: {
        id: 'CapacityPlanningAutomaticMappings',
        defaultMessage: 'Automatic mappings',
    },
    NoAutomaticMappings: {
        id: 'CapacityPlanningNoAutomaticMappings',
        defaultMessage: 'None of the time on this item was mapped automatically.',
    },
    ManualMapping: { id: 'CapacityPlanningManualMapping', defaultMessage: 'Manual mapping' },
    Use: { id: 'CapacityPlanningUse', defaultMessage: 'Use' },
    MappedVia: { id: 'CapacityPlanningMappedVia', defaultMessage: 'Mapped via' },
    SourceTask: { id: 'CapacityPlanningSourceTask', defaultMessage: 'Registered on the task' },
    SourcePriceListItemLink: {
        id: 'CapacityPlanningSourcePriceListItemLink',
        defaultMessage: 'Price-list item of the task template',
    },
    SourceCategoryLink: {
        id: 'CapacityPlanningSourceCategoryLink',
        defaultMessage: 'Category of the price-list item of the task template',
    },
    SourceMapping: { id: 'CapacityPlanningSourceMapping', defaultMessage: 'Manual mapping' },
    ExcludedTaskTimeWarning: {
        id: 'CapacityPlanningExcludedTaskTimeWarning',
        defaultMessage: 'Time registered on a task that is no longer used here, no longer counts for the expected duration of that task.',
    },
    MappedTime: { id: 'CapacityPlanningMappedTime', defaultMessage: '{time} mapped' },
    UnscheduledMapping: {
        id: 'CapacityPlanningUnscheduledMapping',
        defaultMessage: '{time} could not be mapped: these task templates are not scheduled for {count} customers with time on this item.',
    },
    MarkUnproductive: {
        id: 'CapacityPlanningMarkUnproductive',
        defaultMessage: 'Mark as unproductive (not mapped to the planning)',
    },
    AddMapping: { id: 'CapacityPlanningAddMapping', defaultMessage: 'Add mapping' },
    SelectTemplate: {
        id: 'CapacityPlanningSelectTemplate',
        defaultMessage: 'Select task template...',
    },
    NotScheduled: { id: 'CapacityPlanningNotScheduled', defaultMessage: 'not scheduled' },
    Percentage: { id: 'CapacityPlanningPercentage', defaultMessage: '%' },
    SplitBy: { id: 'CapacityPlanningSplitBy', defaultMessage: 'Split by' },
    SplitByFrequency: {
        id: 'CapacityPlanningSplitByFrequency',
        defaultMessage: 'Task periodicity',
    },
    SplitByPercentage: { id: 'CapacityPlanningSplitByPercentage', defaultMessage: 'Percentages' },
    PercentageTotal: {
        id: 'CapacityPlanningPercentageTotal',
        defaultMessage: 'Total {percentage}%: the percentages must add up to 100%.',
    },
    FrequencyModeHint: {
        id: 'CapacityPlanningFrequencyModeHint',
        defaultMessage: 'Only customers with the task template scheduled receive time. With several templates, the time is split by the task periodicity of each template.',
    },
    PercentageModeHint: {
        id: 'CapacityPlanningPercentageModeHint',
        defaultMessage: 'Only customers with the task template scheduled receive time. A share for a template a customer does not have goes to its other templates.',
    },
    RemoveMapping: { id: 'CapacityPlanningRemoveMapping', defaultMessage: 'Remove mapping' },
    TaskTemplate: { id: 'CapacityPlanningTaskTemplate', defaultMessage: 'Task template' },
    Schedules: { id: 'CapacityPlanningSchedules', defaultMessage: 'Schedules with time' },
    Occurrences: { id: 'CapacityPlanningOccurrences', defaultMessage: 'Occurrences' },
    TotalTime: { id: 'CapacityPlanningTotalTime', defaultMessage: 'Total time' },
    AveragePerOccurrence: {
        id: 'CapacityPlanningAveragePerOccurrence',
        defaultMessage: 'Avg. per occurrence',
    },
    CurrentDefault: { id: 'CapacityPlanningCurrentDefault', defaultMessage: 'Current default' },
    NewDefault: { id: 'CapacityPlanningNewDefault', defaultMessage: 'New default' },
    NoData: { id: 'CapacityPlanningNoData', defaultMessage: 'No time registered' },
    NoChange: { id: 'CapacityPlanningNoChange', defaultMessage: 'unchanged' },
    NoDefault: { id: 'CapacityPlanningNoDefault', defaultMessage: 'none' },
    ShareOfMainTaskTime: {
        id: 'CapacityPlanningShareOfMainTaskTime',
        defaultMessage: 'Share of main-task time',
    },
    MainTaskItself: {
        id: 'CapacityPlanningMainTaskItself',
        defaultMessage: 'Stays on the main task',
    },
    UpdateSubtask: { id: 'CapacityPlanningUpdateSubtask', defaultMessage: 'Update subtask' },
    MinutesPerTask: { id: 'CapacityPlanningMinutesPerTask', defaultMessage: 'min per task' },
    DistributeOverSubtasks: {
        id: 'CapacityPlanningDistributeOverSubtasks',
        defaultMessage: '{time} was registered on the main task instead of a subtask. Give subtasks a fixed number of minutes per task or a share of it; what is left stays on the main task.',
    },
    DistributionTotal: {
        id: 'CapacityPlanningDistributionTotal',
        defaultMessage: 'Total {percentage}%: above 100% the distribution is not applied.',
    },
    ValidationIntro: {
        id: 'CapacityPlanningValidationIntro',
        defaultMessage: 'Select what should be updated when the mapping is finalised.',
    },
    ActionDeviations: {
        id: 'CapacityPlanningActionDeviations',
        defaultMessage: 'Fill in expected durations on task schedules',
    },
    ActionDeviationsCount: {
        id: 'CapacityPlanningActionDeviationsCount',
        defaultMessage: '{newCount} new, {changedCount} changed, {unchangedCount} unchanged',
    },
    ActionTemplateDefaults: {
        id: 'CapacityPlanningActionTemplateDefaults',
        defaultMessage: 'Fill in average durations on task templates',
    },
    ActionTemplateDefaultsCount: {
        id: 'CapacityPlanningActionTemplateDefaultsCount',
        defaultMessage: '{count} task templates changed',
    },
    ActionPlannedTasks: {
        id: 'CapacityPlanningActionPlannedTasks',
        defaultMessage: 'Update open planned tasks',
    },
    ActionPlannedTasksCount: {
        id: 'CapacityPlanningActionPlannedTasksCount',
        defaultMessage: '{count} schedule durations; always done together with the task template averages',
    },
    ActionProductivity: {
        id: 'CapacityPlanningActionProductivity',
        defaultMessage: 'Update employee productivity',
    },
    ActionProductivityCount: {
        id: 'CapacityPlanningActionProductivityCount',
        defaultMessage: '{count} employees',
    },
    ShowDetails: { id: 'CapacityPlanningShowDetails', defaultMessage: 'Show details' },
    HideDetails: { id: 'CapacityPlanningHideDetails', defaultMessage: 'Hide details' },
    Employee: { id: 'CapacityPlanningEmployee', defaultMessage: 'Employee' },
    CurrentProductivity: {
        id: 'CapacityPlanningCurrentProductivity',
        defaultMessage: 'Current productivity',
    },
    NewProductivity: {
        id: 'CapacityPlanningNewProductivity',
        defaultMessage: 'New productivity',
    },
});
export default messages;
